import { AddressInput } from '@buy-viasat/types/build/bv';

//TODO: Refactor after createIndividual and updateOrganization have been migrated
type Address = { address: AddressInput };
type ContactMethodId = {
  contactMethodId: string;
};

export type Labels = {
  labels: string[];
};
export type AddressWithLabels = Address & Labels;
export type AddressContactMethod = Address & ContactMethodId & Labels;

export const addressEquality = (addrOne: AddressInput, addrTwo: AddressInput): boolean => {
  const n = Math.min(addrOne.addressLines.length, addrTwo.addressLines.length);

  for (let i = 0; i < n; i++) {
    if (addrOne.addressLines[i] !== addrTwo.addressLines[i]) return false;
  }
  return (
    addrOne.municipality === addrTwo.municipality &&
    addrOne.region === addrTwo.region &&
    addrOne.postalCode === addrTwo.postalCode &&
    addrOne.countryCode === addrTwo.countryCode
  );
};

export const labelEquality = (labelOne: string[], labelTwo: string[]): boolean => {
  if (labelOne.length !== labelTwo.length) return false;

  const inLabelTwo = (val: string): boolean => labelTwo.includes(val);

  return labelOne.every(inLabelTwo);
};

export const addressContactMethodEquality = (original: AddressContactMethod, incoming: AddressWithLabels): boolean =>
  addressEquality(original.address, incoming.address) && labelEquality(original.labels, incoming.labels);
